import type { RootState } from '@shared/redux/root-state';
import type { ViewScope } from './view-scope';
import { buildViewScopeKey } from './view-scope';
import type { ViewFilters } from './view-filters';

export const viewFiltersSelectors = {
  selectFiltersByScope:
    (scope: ViewScope) =>
    (state: RootState): ViewFilters | null => {
      const key = buildViewScopeKey(scope);
      return state.viewFilters.filtersByKey[key] ?? null;
    },
};
